// FormLayout.tsx
import React from 'react';
import { MantineProvider, Container, Paper, Title, Box, createTheme, useMantineTheme } from '@mantine/core';
import { Notifications } from '@mantine/notifications';

interface FormLayoutProps {
  title?: string;
  children: React.ReactNode;
}

// Define your Mantine theme with breakpoints
const theme = createTheme({
  primaryColor: 'orange',
  colors: {
    orange: [
      '#FEF5ED',
      '#FDE3D1',
      '#FCB693',
      '#FA9D73',
      '#F87F4D',
      '#F66A33',
      '#EA580C',
      '#C44B0A',
      '#9E3D08',
      '#783006',
    ],
  },
  fontFamily: 'Poppins, sans-serif',
  headings: {
    fontFamily: 'Poppins, sans-serif',
  },
  // Define breakpoints explicitly
  breakpoints: {
    xs: '36em', // 576px
    sm: '48em', // 768px
    md: '62em', // 992px
    lg: '75em', // 1200px
    xl: '88em', // 1408px
  },
  components: {
    TextInput: {
      styles: () => ({
        input: {
          fontSize: 16,
        },
      }),
    },
  },
});

export default function FormLayout({ title, children }: FormLayoutProps) {
  // Use the hook to get access to theme functions
  const mantineTheme = useMantineTheme();

  return (
    <MantineProvider theme={theme}>
      <Notifications />
      <Container size="sm" mt="lg" style={{ minHeight: '75vh' }}>
        <Paper
          withBorder
          shadow="md"
          p={30}
          radius="md"
          style={{
            width: '100%',
            maxWidth: '500px',
            margin: '0 auto',
            backgroundColor: '#f2f2f2',
            marginTop: '40px',
            '@media (max-width: 768px)': {
              padding: '20px',
              marginTop: '20px',
            },
          }}
        >
          {title && <Title order={3}>{title}</Title>}
          <Box mt="md">{children}</Box>
        </Paper>
      </Container>
    </MantineProvider>
  );
}
